if (!customElements.get('ff-legal-acceptance')) {
  customElements.define('ff-legal-acceptance', class FantasticRgpd extends HTMLElement {

  constructor() {
    super();
    this.check = this.querySelector('#ff-check_legal');
    this.form = this.querySelector('form');
    this.button = this.querySelector('#Subscribe');
    this.error = this.querySelector('#ff-privacy-error');
    this.password = this.querySelector("#RegisterForm-password")
    this.confirmPassword = this.querySelector("#RegisterForm-confirmPassword")
    this.errorPassword = this.querySelector("#ff-password-error")
    this.checkSubmit();
    this.checkChecked();
    this.passwordChecked()
  }

  checkSubmit() {
    this.button && 
      this.button.addEventListener('click', (event) => {
          this.check.checked ? 
          this.error.classList.add('ff-hide-element')
        :
        (
          event.preventDefault(),
          this.error.classList.remove('ff-hide-element')
        )
        if (!(this.password.value === this.confirmPassword.value)) {
          event.preventDefault(),
          this.errorPassword.style.display="block"
        }else{
          this.errorPassword.style.display="none"
        }
      })
  }
  checkChecked() {
    this.check && 
      this.check.addEventListener('click', (event) => {
        this.check.checked ? 
          this.error.classList.add('ff-hide-element')
        :
          this.error.classList.remove('ff-hide-element')
      })
  }
  passwordChecked(){
    if (this.confirmPassword && this.password && this.errorPassword) {
      this.confirmPassword.addEventListener("keyup", () => {
        if (!(this.password.value === this.confirmPassword.value)) {
          this.errorPassword.style.display="block"
        }else{
          this.errorPassword.style.display="none"
        }
       
    })
  }}
});
}

